import { FC } from 'react'
import {
  CustomCalendar,
  ICustomCalendarData,
  ListLoading,
  TableErrorState,
} from '../../../../../../components'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { getCorPlantaoByNome } from '../../hooks/tiposPlantaoStore'

export const PegaPlantaoContent: FC = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { updateState } = useQueryRequest()

  const data: ICustomCalendarData[] = (response ?? []).map((item) => ({
    start: item.Inicio?.replace('+00:00', '')!,
    end: item.Fim?.replace('+00:00', '')!,
    id: item.CodigoPlantao ?? crypto.randomUUID(),
    title: item.ProfDePlantao,
    profissional: item.ProfDePlantao ?? item.ProfFixo,
    especialidade: item.Tipo,
    especialidadeColor: item.Tipo ? `#${getCorPlantaoByNome(item.Tipo)}` : 'var(--bs-success)',
    quantidade: item.Quantidade,
  }))

  return (
    <>
      {/* Sem isso, falha na escala do Pega Plantão aparece como calendário vazio. */}
      {isError && (
        <TableErrorState title='Não foi possível carregar os plantões.' onRetry={() => refetch()} />
      )}
      <CustomCalendar
        events={data}
        onVisibleRangeChange={({ inicio, termino }) => {
          updateState({ inicio, termino })
        }}
        timeZone='local'
      />
      {isLoading && <ListLoading />}
    </>
  )
}
